import { Component, EventEmitter, Output } from '@angular/core';
import { DocumentChecklistListContent } from '@src/app/public/document-checklist/inheritance/content/checklist-content';
import { ButtonModule } from '@vg-constellation/angular-16/button';

@Component({
  selector: 'app-missing-account-type-banner',
  templateUrl: './missing-account-type-banner.component.html',
  styleUrls: ['./missing-account-type-banner.component.scss'],
  standalone: true,
  imports: [ButtonModule],
})
export class MissingAccountTypeBannerComponent {
  content = DocumentChecklistListContent.missingAccountTypeBanner;

  @Output() startTransfer = new EventEmitter<void>();

  onStartTransfer(): void {
    this.startTransfer.emit();
  }
}
